module.exports = __webpack_public_path__ + "img/104005.bd46d95b.png";